/*
 * Generates a locale code in the format 'en-US'
 */
export default function getLocale(lang: string, countryCode: string) {
  return lang.indexOf('-') > -1 ? lang : `${lang}-${countryCode}`;
}
